import React, {useState} from 'react';
import GoodBlock from './GoodBlock'; 


function GoodsContainer(props) {


return (
  <>
      <div class="co-padding gray_bg">
   <div class="box container">
     <div class="multibox-head">
       <ul class="multibox-head__list">
         <li class="active">
           <a href="#">جدیدترین کارها </a>
         </li> 
         {/* <li class="">
           <a href="#">دوره&zwnj;های پیشنهادی</a>
         </li> */}
       </ul> 
       {/* <a href="/series" class="btn-more">مشاهده همه دوره&zwnj;ها</a> */}
     </div> 
     <div class="box_section ">

                                       <GoodBlock
                         title=" کسب درآمد از اینستاگرام" 
                         description="به زودی"
                         price=""
                         imageAddress= {require('./../img/Instagram1.jpg')}/>           
               
                          
               <GoodBlock
                         title="آموزش جذب مشتری" 
                         description="به زودی"
                         price=""
                         imageAddress= {require('./../img/customer-attraction.jpg')}/>    

                         
<GoodBlock
                         title="طراحی یک وب سایت خوب" 
                         description="به زودی"
                         price=""
                         imageAddress= {require('./../img/Best-website-design-poster.jpg')}/>    

                         
<GoodBlock
                         title="کسب درآمد با تلگرام" 
                         description="به زودی"
                         price=""
                         imageAddress= {require('./../img/Telegram1.jpg')}/>    
                         <GoodBlock
                         title="کسب درآمد با تلگرام" 
                         description="به زودی"  
                         price=""
                         imageAddress= {require('./../img/Telegram1.jpg')}/>   
                         <GoodBlock
                         title="کسب درآمد با تلگرام" 
                         description="به زودی"
                         price=""
                         imageAddress= {require('./../img/Telegram1.jpg')}/>   
                         <GoodBlock
                         title="کسب درآمد با تلگرام" 
                         description="به زودی"
                         price=""
                         imageAddress= {require('./../img/Telegram1.jpg')}/>   

                         

      </div>
    </div>
  </div>
  </>
) 
}

export default GoodsContainer;